import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setKotPopup, setKotStatus } from './filterButtonSlice';
import kotIcon from "../../../../../Assets/SVG/KOTfilterIcon.svg"
import CategoryEmptyAnimation from '../Gif/CategoryEmptyAnimation';
import { listKotOrderAPI } from '../../../kitchenOrderTicket/kotAPI\'s';
import { PrintOutlined } from "@mui/icons-material";
import { IconButton, Skeleton } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import KotPrint from '../../../kitchenOrderTicket/components/print/KotPrint';
import { setBillLoading, setKOTSingleInfo } from '../Slice/billingScreenSlice';
import { useReactToPrint } from 'react-to-print';
import  html2pdf  from 'html2pdf.js';
import { pdfBlobOptionsPrint } from '../../../../Single Components/GneralUtilities';
import { kotPrintRequestAPICall, printRequestAPICall } from '../../../Settings/Device Settings/deviceSettingsAPI';
import { getPPI } from '../../../../../Js/generalFunctions';
function KOTorders() {

    const menuRef=useRef()
    const dispatch=useDispatch()
    const kotPrintRef=useRef(null)
    const {kotPopup,kotStatusFilter}=useSelector((state)=>state.filterButtonSlice)
    const { kotOrderList } = useSelector((state) => state.kitchenOrderTicketSlice);
    const { kotSingleData } = useSelector((state) => state.billingScreenSlice);
    const { tableLoading } = useSelector((state) => state.mainDashBoardSlice);
    const userInfo=useSelector((state)=>state.loginResponseSlice.value)
    const userShiftStatus = localStorage.getItem("shiftStatus");
    const userShiftpk = JSON.parse(userShiftStatus)?._id
    const [printData, setPrintData] = useState(null)
    const [pendingTrigger, setPendingTrigger] = useState(0)
    const [isPrinting, setIsPrinting] = useState(false)
    const lastPayloadRef = useRef(null)

    const switchTabs=["All","To Cook","Preparing","Completed"]
    const onChangeBillType=(key)=>()=>{
        dispatch(setKotStatus(key))
        let filter=key==="All"?"ONGORD":key==="To Cook"?"NEW":key==="Preparing"?"PREPARING":"COMPLETED"

        listKotOrderAPI({ body: {branchId:userInfo?.branchPk,status:filter,shiftId:userShiftpk} });

    }
    const filterIconClick = () => {
        dispatch(setKotPopup(!kotPopup))

        let key=kotStatusFilter
        let filter=key==="All"?"ONGORD":key==="To Cook"?"NEW":key==="Preparing"?"PREPARING":"COMPLETED"

       !kotPopup && listKotOrderAPI({ body: {branchId:userInfo?.branchPk,status:filter,shiftId:userShiftpk} });
    }
    
    const handlePrintKot=useReactToPrint({
      content: () => kotPrintRef.current,
      documentTitle: 'KOT',
      removeAfterPrint: false,
      pageStyle: `
        @page {
          size: 80mm auto;
          margin: 0;
        }
        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `
    })

    const kotPrintClick = async (info) => {
      console.log('KOTorders - kotPrintClick called with info:', info);
      console.log('KOTorders - kotPrintClick orderInfo:', info?.orderInfo);
      console.log('KOTorders - kotPrintClick kotSingleData:', kotSingleData);
      console.log('KOTorders - kotPrintClick local printData:', printData);
      dispatch(setBillLoading(true));
      console.log('KOTorders - Setting isPrinting to TRUE');
      setIsPrinting(true); // Prevent popup from closing
      try {
        let printSettingsString = localStorage.getItem('PrinterSettings');
        let printSettings = JSON.parse(printSettingsString);
        const payload = {
          printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
          printerName: printSettings?.kotPrinter,
          enableNativeName: printSettings?.enableKotNativeName || false,
          transNo: info?.transNo,
          ordName: info?.ordName,
          orderDate: info?.orderDate,
          ordType: info?.ordType,
          waiterName: info?.waiterName || "-NIL-",
          orderInfo: info?.orderInfo,
          tables: info?.tables,
          floorName: info?.floorName,
          kotPrintNotes: printSettings?.kotPrintNotes || false,
        };
        console.log('KOTorders - prepared payload:', payload);
        // Store info into local state then trigger effect to print after DOM commits
        setPrintData(info);
        setPendingTrigger((v) => v + 1);
        // Persist payload to a ref for the effect-driven print
        lastPayloadRef.current = payload;
      } catch (error) {
        console.error('KOTorders - Print error (prep):', error);
        dispatch(setBillLoading(false));
        setIsPrinting(false);
      }
    };

    // After printData updates and component renders, perform the actual print
    useEffect(() => {
      let active = true;
      const doPrint = async () => {
        if (!printData || pendingTrigger === 0) return;
        // Allow next paint to ensure DOM reflects printData
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
        console.log('KOTorders - printing with printData:', printData);
        console.log('KOTorders - orderInfo length:', Array.isArray(printData?.orderInfo) ? printData?.orderInfo?.length : 'not-array');
        if (!Array.isArray(printData?.orderInfo) || printData?.orderInfo?.length === 0) {
          console.warn('KOTorders - Aborting print: orderInfo missing or empty');
          dispatch(setBillLoading(false));
          return;
        }
        console.log('KOTorders - print HTML preview:', kotPrintRef.current?.innerHTML);
        try {
          let printSettingsString = localStorage.getItem('PrinterSettings');
          let printSettings = JSON.parse(printSettingsString);
          const payload = lastPayloadRef.current || {
            printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
            printerName: printSettings?.kotPrinter,
            enableNativeName: printSettings?.enableKotNativeName || false,
            transNo: printData?.transNo,
            ordName: printData?.ordName,
            orderDate: printData?.orderDate,
            ordType: printData?.ordType,
            waiterName: printData?.waiterName || "-NIL-",
            orderInfo: printData?.orderInfo,
            tables: printData?.tables,
            floorName: printData?.floorName,
            kotPrintNotes: printSettings?.kotPrintNotes || false,
          };

          // Use thermal printer or browser print
          // Priority: Socket Print > Thermal utility > Browser print
          if (printSettings?.useSocketPrint && printSettings?.kotPrinter) {
            // Socket Print mode - silent KOT print via Socket.IO
            console.log('Using Socket Print for silent KOT print...');
            try {
              const { socketKotThermalPrint } = await import('../../../Settings/Device Settings/socketPrintService');
              await socketKotThermalPrint(payload);
              // Socket print succeeded - do NOT open browser print dialog
            } catch (socketErr) {
              console.error('Socket KOT print failed, falling back to thermal utility:', socketErr);
              kotPrintRequestAPICall(payload, handlePrintKot);
            }
          } else if (printSettings?.kotPrinter) {
            // Send to thermal printer via API
            kotPrintRequestAPICall(payload, handlePrintKot);
          } else {
            // Use html2pdf for browser print (more reliable than react-to-print)
            const receiptHTML = kotPrintRef.current;
            if (!receiptHTML) {
              console.error('KOTorders - kotPrintRef.current is null');
              return;
            }
            
            // Measure height to set proper PDF page size
            const contentHeight = receiptHTML?.offsetHeight || 400;
            const ppi = getPPI();
            const pixelsToMM = (pixels) => pixels * (25.4 / ppi);
            const contentHeightInMM = Math.max(40, pixelsToMM(contentHeight));
            const widthMM = 80; // KOT width
            
            const opt = {
              margin: 0,
              filename: `KOT-${printData?.ordName || 'print'}.pdf`,
              html2canvas: { scale: 3, useCORS: true },
              jsPDF: { unit: 'mm', format: [widthMM, contentHeightInMM * 1.1] },
            };
            
            // Generate PDF and open print dialog
            html2pdf().from(receiptHTML).set(opt).toPdf().get('pdf').then(function(pdf) {
              // Open PDF in iframe and trigger print
              const blob = pdf.output('blob');
              const url = URL.createObjectURL(blob);
              const iframe = document.createElement('iframe');
              iframe.style.position = 'fixed';
              iframe.style.right = '0';
              iframe.style.bottom = '0';
              iframe.style.width = '0';
              iframe.style.height = '0';
              iframe.style.border = 'none';
              iframe.src = url;
              document.body.appendChild(iframe);
              
              iframe.onload = function() {
                setTimeout(() => {
                  iframe.contentWindow.focus();
                  iframe.contentWindow.print();
                  
                  // Keep popup open for 15 seconds to allow user to interact with print dialog
                  setTimeout(() => {
                    console.log('KOTorders - Resetting printing flag after 15s');
                    setIsPrinting(false);
                  }, 15000);
                  
                  // Clean up iframe after a delay
                  setTimeout(() => {
                    try {
                      document.body.removeChild(iframe);
                      URL.revokeObjectURL(url);
                    } catch (e) {
                      console.error('Cleanup error:', e);
                    }
                  }, 1000);
                }, 100);
              };
            });
          }
        } catch (err) {
          console.error('KOTorders - Print error (execute):', err);
          setIsPrinting(false); // Reset on error
        } finally {
          dispatch(setBillLoading(false));
        }
      };
      doPrint();
      return () => {
        active = false;
      };
    }, [printData, pendingTrigger]);
    // const kotPrintClick=async()=>{
    //   dispatch(setBillLoading(true))
    //   try {
    //       const receiptHTML = kotPrintRef.current;
    //       const contentHeight = receiptHTML.offsetHeight;
    //       const ppi = getPPI();
    //       // Convert inches to mm for jsPDF
    //       const pixelsToMM = (pixels) => pixels * (25.4 / ppi);
    //       const contentHeightInMM = pixelsToMM(contentHeight);
          
    //       const opt = {
    //         margin: 0,
    //         filename: 'receipt.pdf',
    //         html2canvas: { scale: 4, useCORS: true },
    //         jsPDF: { unit: 'mm', format: [80, contentHeightInMM*1.2] }
    //       };
    //       // Convert to PDF
    //       const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
          
    //       let printSettingsString=localStorage.getItem('PrinterSettings')
    //       let printSettings=JSON.parse(printSettingsString)
          
    //       const formData = new FormData();
    //       formData.append('pdfFile', pdfBlob);
    //       formData.append('printer_name',printSettings?.kotPrinter);
    //       printRequestAPICall(formData,handlePrintKot)
    //   } catch (error) {
    //       dispatch(setBillLoading(false))
    //   } finally {
    //     dispatch(setBillLoading(false));
    //   }
      
    // }
    const kotSinglePrint=(row)=>(event)=>{
      // Stop event propagation to prevent handleClickOutside from firing
      event.stopPropagation();
      console.log('kotSinglePrint called with row:', row);
      console.log('kotSinglePrint orderInfo:', row?.orderInfo);
      // Optimistically set Redux, but rely on local printData for immediate print
      dispatch(setKOTSingleInfo(row));
      // Prepare and trigger print; use effect will execute print after render
      kotPrintClick(row);
    }

    // Log kotPopup state changes
    useEffect(() => {
        console.log('KOTorders - kotPopup state changed to:', kotPopup);
    }, [kotPopup]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            console.log('KOTorders - handleClickOutside triggered, isPrinting:', isPrinting);
            // Don't close popup if printing is in progress
            if (isPrinting) {
                console.log('KOTorders - Blocking popup close, printing in progress');
                return;
            }
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) 
            ) {
                console.log('KOTorders - Closing popup (clicked outside)');
                dispatch(setKotPopup(false))
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isPrinting, dispatch]);
    return (
        <div
        ref={menuRef}
        style={{position:"relative"}}>
        <div 
        className="filter-icon-ctn justify-center" 
        style={{backgroundColor:"#ffdfe0",color:"rgb(233 58 56)",padding:"15px 8px"}}
        onClick={filterIconClick}>
            <img
            style={{height:"20px",width:"20px"}}
            src={kotIcon} alt="" />
            <span>
            KOT
            </span>
        </div>
            {
                kotPopup &&
                <div className="kot-list-ctn filter-icon-ctn-drop-down">
                    <div className="justify-space-between">

                    <h4 style={{margin:"0px"}}>KOT</h4>
                    <div
                    className="new-billing-order-type-switch"
                    style={{width:"auto"}}
                  >
                    {
                      switchTabs?.map((option) => (
                        <div
                          key={option}
                          className={`switch-bill-type ${kotStatusFilter === option ? 'active' : ''}`}
                          onClick={onChangeBillType(option)}
                          style={{paddingBottom:kotStatusFilter === option ?0:"4px"}}
                        >
                          <p readOnly style={{ margin: "0", fontSize: "0.9rem" }}>
                            {option}
                          </p>
                        </div>
                      ))
                    }
                  </div>
                  </div>
                  <hr className="global-hr" style={{marginTop:"0px"}}/>

                  <div className="billing-kot-list-body">
                        {

                        tableLoading?
                        [...Array(10)].map((_,i)=>(
                          <div
                              key={i}
                              style={{ backgroundColor: "#fff" ,width:"100%"}}>
                                  <Skeleton width={"100%"} height={90} />

                          </div> 
                      ))
                        :kotOrderList.length!==0?
                        kotOrderList.map((r,i)=>(
                            <div className="kot-order-card" key={i} style={{padding:r?.status!=="DELIVERED" ?"10px 15px":"0 15px" }}>
                            <div className="justify-space-between" style={{marginBottom:r?.status!=="DELIVERED" ?"15px":"0px"}}>
                                <p>
                                KOTNO:&nbsp;<span style={{color:"red"}}>{r?.name || "---"}</span>
                                </p>
                                <div className="justify-center" style={{gap:"15px"}}>
                                    <p>O/No:&nbsp; <span style={{color:"#1438f9"}}>{r?.ordName ||"---"}</span></p>
                                    {
                                      r?.status!=="DELIVERED"?
                                    <div className={`status ${r?.status==="NEW"?"status-red":r?.status==="PREPARING"?"status-blue":"status-green"}`}>
                                        {r?.status==="NEW"?"To Cook":r?.status==="PREPARING"?"Preparing":r?.status==="COMPLETED"?"Completed":"---"}
                                    </div>:
                                    <span><DoneIcon color='success' fontSize='large'/></span>
                                    }
                                    <IconButton onClick={kotSinglePrint(r)}>
                                      <PrintOutlined/>
                                    </IconButton>
                                </div>
                            </div>
                            {
                            r?.status!=="DELIVERED" &&
                            r?.orderInfo.map((product,index)=>(
                                <div 
                                key={index}
                                className="kot-order-item-list justify-space-between"
                                >

                                <p>{product?.productName}</p>
                                <p>{product?.qty}</p>
                            </div>
                            ))
                            }
                        </div>
                        )):
                      <div className="center-div" style={{ height: "50vh", flexDirection: "column" }}>
                        <CategoryEmptyAnimation />
                        No Records !!
                      </div>    
                        }
                  </div>
                  <div className='receipt-print-parent'>
          <div ref={kotPrintRef}>
            <KotPrint
              key={printData?._id || kotSingleData?._id || pendingTrigger}
              billNo={(printData?.ordName) || (kotSingleData?.ordName) || "-NIL-"}
              waiter={(printData?.waiterName) || (kotSingleData?.waiterName) || "-NIL-"}
              orderDate={(printData?.orderDate) || (kotSingleData?.orderDate) || "00/00/0000 00:00:00"}
              orderData={(printData?.orderInfo) || (kotSingleData?.orderInfo) || []}
              orderType={(printData?.ordType) || (kotSingleData?.ordType) || "---"}
              tokenNumber={(printData?.transNo) || (kotSingleData?.transNo) || "---"}
              kotPrintNotes={JSON.parse(localStorage.getItem('PrinterSettings') || '{}')?.kotPrintNotes || false}
            />
          </div>
        </div>
                </div>
            }


        
        </div>
    )
}

export default KOTorders